import React, { useState, useEffect } from "react";
import { MenuItems } from "./MenuItems";
import "./Navbar.css";
import logo from "../../Images/logo.png";
import { Button } from "../Button/button";
import { getAuth } from "firebase/auth";
import { app } from "../firebase/firebase-config";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import axios from "axios"; // Import axios to fetch user details
import { NavLink, useLocation } from "react-router-dom";
import { useMobileNav } from "../../contexts/MobileNavContext";

const auth = getAuth(app);

const NavbarComponent = () => {
	// State to track if a user is logged in
	const [loggedIn, setLoggedIn] = useState(null);

	// State to store the user's role (e.g., admin, user, etc.)
	const [userRole, setUserRole] = useState("");
	// State to store the user's first and last name
	const [userName, setUserName] = useState("");

	// Mobile navigation context
	const { toggleSidebar } = useMobileNav();

	// Get current location to determine if we're on account page
	const location = useLocation();
	const isOnAccountPage = location.pathname === '/account';

	/**
	 * Fetch the logged-in user's role and name from the backend database.
	 * @param {string} email - The email of the logged-in user.
	 */
	const fetchUserRole = async (email) => {
		try {
			const user = auth.currentUser; // Get the current user from Firebase auth
			if (user) {
				const email = user.email; // Retrieve user's email

				// Fetch all users from the backend
				const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`);

				// Find the logged-in user by matching the email (case-insensitive)
				const loggedInUser = response.data.find((user) => user.email && user.email.toLowerCase() === email.toLowerCase());
				if (loggedInUser) {
					setUserRole(loggedInUser.role); // Update the user role state
					setUserName(loggedInUser.firstname); // Update the user name state
				} else {
					console.log("No matching user found in the database.");
				}
			} else {
				console.log("No user is currently logged in.");
			}
		} catch (error) {
			console.error("Error fetching user role:", error);
		}
	};

	/**
	 * Checks if a user is logged in and fetches their role from the database.
	 */
	useEffect(() => {
		auth.onAuthStateChanged((user) => {
			if (user) {
				setLoggedIn(user); // Update loggedIn state
				fetchUserRole(user.email); // Fetch the user's role
			} else {
				setLoggedIn(null); // No user is logged in
				setUserRole(""); // Reset the role
				setUserName(""); // Reset the name
			}
		});
	}, []);

	// Handle navbar toggle - if on account page, also toggle sidebar
	const handleNavbarToggle = () => {
		if (isOnAccountPage && loggedIn) {
			toggleSidebar();
		}
	};

	return (
		<Navbar
			collapseOnSelect
			expand="lg"
			bg="light"
			className="my-0"
			variant="light"
			style={{
				height: "70px",
				backgroundColor: "#ffffff",
				boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
				position: "fixed",
				top: 0,
				width: "100%",
				zIndex: 1000,
			}}
		>
			<Container fluid>
				{/* Navbar Brand - Logo */}
				<Navbar.Brand href="/home" className="d-flex align-items-center">
					<img src={logo} alt="Logo" style={{ height: "40px" }} />
					<h1>Woo Woo</h1>
				</Navbar.Brand>

				{/* Toggle button for mobile view - now controls both navbar and sidebar on account page */}
				<Navbar.Toggle
					aria-controls="responsive-navbar-nav"
					onClick={handleNavbarToggle}
					className={isOnAccountPage && loggedIn ? "account-page-toggle" : ""}
					title={isOnAccountPage && loggedIn ? "Toggle sidebar menu" : "Toggle navigation menu"}
				/>

				{/* Collapsible Navbar Section - Hide on account page */}
				{!isOnAccountPage && (
					<Navbar.Collapse id="responsive-navbar-nav" className="w-100">
						<div className="d-flex justify-content-start">
							<Nav className="me-auto" style={{ width: "fit-content" }}>
								{/* Render menu items dynamically */}
								{MenuItems.map((item, index) => (
									<Nav.Link
										key={index}
										href={item.url}
										className="px-4"
										style={{ backgroundColor: "#f8f9fa" }}
									>
										{item.title}
									</Nav.Link>
								))}
							</Nav>
						</div>

						{/* Right Section: Sign In/Sign Out and User Role */}
						<div className="ms-auto d-flex align-items-center">
							{loggedIn ? (
								<>
									{/* Account button */}
									<Nav.Link href="/account" className="px-4">
										{userName && userRole ? (
											<span style={{ display: 'inline-flex', alignItems: 'center' }}>
												<svg width="20" height="20" viewBox="0 0 20 20" style={{ marginRight: 6 }} fill="none" xmlns="http://www.w3.org/2000/svg">
													<circle cx="10" cy="10" r="10" fill="#26a899" />
													<circle cx="10" cy="7" r="3" fill="#fff" />
													<ellipse cx="10" cy="14" rx="5" ry="3" fill="#fff" />
												</svg>
												{userName} ({userRole.charAt(0).toUpperCase() + userRole.slice(1)})
											</span>
										) : "Account"}
									</Nav.Link>

									{/* Sign Out button */}
									<Nav.Link
										href="/signout" className="px-4">
										Sign Out
									</Nav.Link>

									{/* Display the user's role */}
									{/* <Nav.Item>
										<span
											className="badge bg-primary"
											style={{
												padding: "0.5rem 1rem",
												borderRadius: "20px",
												fontSize: "0.9rem",
											}}
										>
											{userRole.charAt(0).toUpperCase() + userRole.slice(1)}
										</span>
									</Nav.Item> */}
								</>
							) : (
								<>
									{/* Sign In button */}
									{/* <Nav.Link
										href="/signin"
									>
										<Button >Sign In</Button>
									</Nav.Link>

									{/* Sign Up button 
									<Nav.Link href="/signup">
										<Button>Sign Up</Button>
									</Nav.Link> */}
									<Nav.Link href="/login"
										className="px-4">
										Login
									</Nav.Link>
								</>
							)}
						</div>
					</Navbar.Collapse>
				)}
			</Container>
		</Navbar>
	);
};

export default NavbarComponent;
